import { scorePasswordHeuristic } from '../services/passwordHeuristic'
import type { VaultItem } from '../types'
import { useTranslation } from '@/i18n'

/**
 * login アイテムのパスワード強度バッジ (強い / 普通 / 弱い、ookey-browser 準拠)。
 *
 * `scorePasswordHeuristic` (0-4) を 3 段階に丸める: >=3 強い / 2 普通 / それ以外 弱い。
 * login 以外 / パスワード空は `null` を返し描画しない。ホーム一覧・お気に入り・
 * Vault 詳細で共用する (`.strength-pill` CSS が配色を担当)。
 */
type StrengthBucket = 'strong' | 'medium' | 'weak'

const STRENGTH_LABEL_KEY: Record<StrengthBucket, string> = {
  strong: 'vault.strength.strong',
  medium: 'vault.strength.medium',
  weak: 'vault.strength.weak',
}

const strengthBucketOf = (item: VaultItem): StrengthBucket | null => {
  if (item.payload.type !== 'login') return null
  const pw = item.payload.password ?? ''
  if (pw === '') return null

  const score = scorePasswordHeuristic(pw)
  if (score >= 3) return 'strong'
  if (score === 2) return 'medium'

  return 'weak'
}

export const VaultStrengthBadge = ({ item }: { item: VaultItem }): JSX.Element | null => {
  const { t } = useTranslation()
  const bucket = strengthBucketOf(item)
  if (bucket === null) return null

  return <span className={`strength-pill is-${bucket}`}>{t(STRENGTH_LABEL_KEY[bucket])}</span>
}
